import { throttle } from 'next/javascripts/modules/utils';
import editorActionPendingMixin from './editor-action-pending-mixin';

export default {
  mixins: [editorActionPendingMixin],

  connected() {
    this.initStickyPanel();

    this.listenTo(this, 'tr-editor:editorReady', (event) => {
      event.stopPropagation();

      const submitButton = this.querySelector('form.tr-form button[type="submit"]');
      if (!submitButton) return;

      const { editor } = event.detail;
      editor.editing.view.document.on('enter', (evt, data) => {
        const { domEvent } = data;

        if (domEvent.ctrlKey || domEvent.metaKey) {
          data.preventDefault();
          data.stopPropagation();
          evt.stop();
          submitButton.click();
        }
      });
    });
  },

  initStickyPanel() {
    this.trEditor = this.querySelector('tr-editor');
    this.stickyPanel = this.querySelector('tr-sticky-panel');

    this.listenTo(this, {
      'tr-editor:changesRendered': throttle(this.repositionStickyPanel.bind(this), 100),
      'tr-editor:focus': (event) => {
        this.repositionStickyPanel();
        event.target.scrollToTheSelection();
      },
    });
  },

  repositionStickyPanel() {
    const { stickyPanel, trEditor: editor } = this;
    if (!stickyPanel || !editor) return;

    stickyPanel.checkSticky();
    setTimeout(async () => {
      if (!stickyPanel.isSticky) return;

      const selectionElement = await editor.getSelectionParentElement();
      if (!selectionElement) return;

      const { height: offset } = stickyPanel.getBoundingClientRect();
      if (!stickyPanel.targetIsBelow(selectionElement)) return;

      if (stickyPanel.scrollContainerElement) {
        stickyPanel.scrollContainerElement.scrollTop += offset;
      } else {
        window.scrollTo(window.scrollX, window.scrollY + offset);
      }
    });
  },
};
